import LcdChair from "./../assets/img/lcdChair.png";
import iconicChair from "./../assets/img/iconicChair.png";
import DiningChair from "./../assets/img/diningChair.png";
import ArmChair from "./../assets/img/armChair.png";
import ModernChair from "./../assets/img/modernChair.png";
import PlasticChair from "./../assets/img/plasticChair.png";
import WoodChair from "./../assets/img/woodChair.png";
import ElegantChair from "./../assets/img/elegantChair.png";
import FiveStar from "./../assets/img/fiveStar.png";
import FourStar from "./../assets/img/fourStar.png";
import MinLcdChair from "./../assets/img/minLcdChair.png";
import ModChair from "./../assets/img/ModChair.png";
import MicrofiberChair from "./../assets/img/microChair.png";
import CoffeChair from "./../assets/img/coffeChair.png";
import ClubChair from "./../assets/img/clubChair.png";
import CowhideChair from "./../assets/img/cowhiceChair.png";
import StorageChair from "./../assets/img/storageChair.png";
import ThreePieceChair from "./../assets/img/threPieceChair.png";

export const data = [
  {
    id: 1,
    title: "Minimal LCD chair",
    name: "Chair",
    img: `${LcdChair}`,
    price: "$180",
    sale: "$250",
    rating: `${FiveStar}`,
    type: "New",
  },
  {
    id: 2,
    title: "Minimal iconic chair",
    name: "Chair",
    img: `${iconicChair}`,
    price: "$120",
    sale: "$150",
    rating: `${FourStar}`,
    type: "New",
  },
  {
    id: 3,
    title: "Dining chairs",
    name: "Chair",
    img: `${DiningChair}`,
    price: "$100",
    sale: "$120",
    rating: `${FiveStar}`,
    type: "Sale",
  },
  {
    id: 4,
    title: "Buskbo armchair",
    name: "Chair",
    img: `${ArmChair}`,
    price: "$130",
    sale: "$150",
    rating: `${FourStar}`,
    type: "Sale",
  },
  {
    id: 5,
    title: "Modern chairs",
    name: "Chair",
    img: `${ModernChair}`,
    price: "$100",
    sale: "$120",
    rating: ``,
    type: "Sale",
  },
  {
    id: 6,
    title: "Plastic dining chair",
    name: "Chair",
    img: `${PlasticChair}`,
    price: "$130",
    sale: "$150",
    rating: `${FourStar}`,
    type: "Sale",
  },
  {
    id: 7,
    title: "Minimal Wood chair",
    name: "Chair",
    img: `${WoodChair}`,
    price: "$180",
    sale: "$250",
    rating: `${FiveStar}`,
    type: "New",
  },
  {
    id: 8,
    title: "Elegent wood chair",
    name: "Chair",
    img: `${ElegantChair}`,
    price: "$120",
    sale: "$150",
    rating: `${FourStar}`,
    type: "New",
  },
  {
    id: 9,
    title: "Minimal LCD chair",
    name: "Chair",
    img: `${MinLcdChair}`,
    price: "$180",
    sale: "$250",
    rating: `${FiveStar}`,
    type: "Sale",
  },
  {
    id: 10,
    title: "Modern Sofa",
    name: "Sofa",
    img: `${ModChair}`,
    price: "$120",
    sale: "$150",
    rating: `${FourStar}`,
    type: "New",
  },
  {
    id: 11,
    title: "Microfiber Sofa",
    name: "Sofa",
    img: `${MicrofiberChair}`,
    price: "$130",
    sale: "$150",
    rating: `${FourStar}`,
    type: "-30%",
  },
  {
    id: 12,
    title: "Wood Coffee Tables",
    name: "Tabble",
    img: `${CoffeChair}`,
    price: "$100",
    sale: "$120",
    rating: `${FiveStar}`,
    type: "Sale",
  },
  {
    id: 13,
    title: "Acacia Wood Club Chairs",
    name: "Chair",
    img: `${ClubChair}`,
    price: "$100",
    sale: "$120",
    rating: ``,
    type: "-30%",
  },
  {
    id: 14,
    title: "Amalia Cowhide Bench",
    name: "Bench",
    img: `${CowhideChair}`,
    price: "$130",
    sale: "$150",
    rating: `${FourStar}`,
    type: "Sale",
  },
  {
    id: 15,
    title: "Juno-Hinged Lid Storage",
    name: "Storage",
    img: `${StorageChair}`,
    price: "$180",
    sale: "$250",
    rating: `${FiveStar}`,
    type: "New",
  },
  {
    id: 16,
    title: "Delicia 3 Piece Living Room",
    name: "Furniture",
    img: `${ThreePieceChair}`,
    price: "$120",
    sale: "$150",
    rating: `${FourStar}`,
    type: "New",
  },
];
